import { useState } from "react";

// Hook per gestionar la càrrega en cascada Província → Municipi → Població; usat a OfertaPartner i OfertaPagador.
export const useAddressFields = ({
    get_provincias,
    get_municipios,
    get_poblaciones,
    partnerLoading = false
}) => {
    const [loadingProv, setLoadingProv] = useState(false);
    const [loadingMuni, setLoadingMuni] = useState(false);
    const [loadingPob, setLoadingPob] = useState(false);

    const [error, setError] = useState(null);

    // Carrega les províncies del país indicat; no fa res si ja s'està carregant el partner
    const fetchProvincias = async (paisId) => {
        if (!paisId || partnerLoading) return;
        setLoadingProv(true);
        setError(null);
        try {
            await get_provincias(paisId);
        } catch (e) {
            console.error("Error fetching provincias:", e);
            setError("Error al cargar provincias. Intente nuevamente.");
        } finally {
            setLoadingProv(false);
        }
    };

    // Carrega els municipis de la província indicada
    const fetchMunicipios = async (provId) => {
        if (!provId || partnerLoading) return;
        setLoadingMuni(true);
        setError(null);
        try {
            await get_municipios(provId);
        } catch (e) {
            console.error("Error fetching municipios:", e);
            setError("Error al cargar municipios.");
        } finally {
            setLoadingMuni(false);
        }
    };

    // Carrega les poblacions del municipi indicat
    const fetchPoblaciones = async (muniId) => {
        if (!muniId || partnerLoading) return;
        setLoadingPob(true);
        setError(null);
        try {
            await get_poblaciones(muniId);
        } catch (e) {
            console.error("Error fetching poblaciones:", e);
            setError("Error al cargar poblaciones.");
        } finally {
            setLoadingPob(false);
        }
    };

    return {
        loadingProv,
        loadingMuni,
        loadingPob,
        error,
        fetchProvincias,
        fetchMunicipios,
        fetchPoblaciones
    };
};

export default useAddressFields;